function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.82456 16.3401L5.77794 15.3934C4.73404 14.4561 3.91384 13.2965 3.37783 11.9999C4.73123 8.61978 8.46474 5.99966 11.9982 5.99966C12.9075 6.01166 13.8086 6.17385 14.665 6.47968L15.6984 5.43963C14.5268 4.94449 13.2701 4.68183 11.9982 4.66626C9.82515 4.74798 7.72363 5.46467 5.95342 6.72775C4.18321 7.99083 2.82191 9.74493 2.03777 11.7733C1.98481 11.9197 1.98481 12.0801 2.03777 12.2266C2.62996 13.798 3.58479 15.2074 4.82456 16.3401V16.3401Z",
  fill: "#767B87"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.33206 11.82C9.37842 11.1811 9.6532 10.5802 10.1061 10.1273C10.5591 9.67432 11.16 9.39954 11.7988 9.35318L13.0056 8.13978C12.3294 7.96174 11.6183 7.96405 10.9433 8.14649C10.2683 8.32893 9.65288 8.68513 9.15845 9.17956C8.66401 9.674 8.30781 10.2894 8.12537 10.9644C7.94293 11.6394 7.94062 12.3505 8.11867 13.0267L9.33206 11.82Z",
  fill: "#767B87"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.9583 11.7734C21.1938 9.78207 19.8636 8.05787 18.1315 6.81312L21.3316 3.6063L20.3916 2.66626L2.66406 20.3938L3.60411 21.3338L7.00427 17.9337C8.52026 18.823 10.2405 19.3053 11.9978 19.3337C14.1709 19.252 16.2725 18.5353 18.0427 17.2722C19.8129 16.0092 21.1742 14.255 21.9583 12.2267C22.0113 12.0802 22.0113 11.9198 21.9583 11.7734ZM14.6646 12C14.6618 12.4668 14.5366 12.9246 14.3014 13.3278C14.0661 13.731 13.7292 14.0654 13.3243 14.2975C12.9194 14.5297 12.4606 14.6515 11.9938 14.6508C11.5271 14.6501 11.0687 14.5269 10.6644 14.2935L14.2913 10.6666C14.531 11.0705 14.6598 11.5305 14.6646 12ZM11.9978 18.0003C10.5992 17.9759 9.22697 17.6145 7.99765 16.9469L9.69106 15.2535C10.4613 15.788 11.3948 16.0349 12.3286 15.9512C13.2624 15.8675 14.1371 15.4585 14.8 14.7956C15.4629 14.1326 15.872 13.2579 15.9557 12.3241C16.0394 11.3904 15.7924 10.4569 15.258 9.68659L17.1714 7.77317C18.7012 8.82321 19.8975 10.2902 20.6183 12C19.2649 15.3802 15.5313 18.0003 11.9978 18.0003Z",
  fill: "#767B87"
});

const SvgViewChecked = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgViewChecked, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/view_checked.7f169589.svg";
export { ForwardRef as ReactComponent };